import type { Audience } from "@/content";
import { AudienceToggle } from "./AudienceToggle";
import { Logo } from "./Logo";

const LINKS = [
  { href: "#problema", label: "El problema" },
  { href: "#flujos", label: "Cómo funciona" },
  { href: "#solucion", label: "La solución" },
  { href: "#faq", label: "Preguntas" },
];

type NavProps = {
  audience: Audience;
  onAudienceChange: (audience: Audience) => void;
  /** Reveal the compact audience switch (once the hero one scrolls away). */
  showSwitch: boolean;
};

/**
 * Sticky top nav. Translucent + blur so the hero glow reads through it. Once
 * the hero's audience switch scrolls out of view, a compact copy fades in here
 * so the two-audience choice stays reachable and visible the whole way down.
 */
export function Nav({ audience, onAudienceChange, showSwitch }: NavProps) {
  return (
    <header className="sticky top-0 z-50 border-b border-[var(--separator)] bg-[color-mix(in_oklch,var(--background)_78%,transparent)] backdrop-blur-md">
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <a href="#top" className="flex items-center gap-2" aria-label="Ciam — inicio">
          <Logo />
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-[var(--muted)] transition-colors hover:text-[var(--foreground)]"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          {showSwitch && (
            <div className="animate-fade-in">
              <AudienceToggle value={audience} onChange={onAudienceChange} compact />
            </div>
          )}
          <a
            href="#waitlist"
            className="inline-flex items-center justify-center rounded-[var(--radius)] bg-[var(--accent)] px-3.5 py-2 text-sm font-medium text-[var(--accent-foreground)] transition-opacity hover:opacity-90"
          >
            Sumate a la lista
          </a>
        </div>
      </nav>
    </header>
  );
}
